import isHTML from 'is-html';

/**
 * Create a {@link HTMLDomElement} from the given string
 * @category dom
 * @module create
 * @param {string|HTMLDOMElement} str - Can be a CSS selector, an HTML string, or a DOM element
 */
export default function create(str){
	if(isHTML(str)) 	return html2dom(str);
	if(isDOM(str)) 		return str;
	if(isSelector(str)) return selector2dom(str);
	return null;
}


/**
 * Create a {@link HTMLDomElement} from the given HTML string
 * @param {string} htmlString - an HTML string
 */
export function html2dom(htmlString){
  	var div = document.createElement('div');
  		div.innerHTML = htmlString.trim();
    return div.childNodes && div.childNodes.length > 1 ? div.childNodes : div.firstChild;
}

/**
 * Create a {@link HTMLDomElement} from the given selector
 * @param {string} selector - a CSS selector
 */
export function selector2dom(selector){
  	return document.querySelector(selector);
}

function isDOM(element){
	return element instanceof window.Node;
}

const isSelector = (qs => (
  selector => {
    try { qs(selector) } catch (e) { return false }
    return true
  }
))(s => document.createDocumentFragment().querySelector(s))


export { create };